// extracted by mini-css-extract-plugin
export default {"Info":"Page_Info__NRaQz"};